import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch, useLocation, useParams } from 'react-router';
import { getCurrentAnnotationId, isValidationPathname } from '../../../lib/url';
import { exitAnnotation } from '../../../redux/modules/annotation/actions';
import {
  documentNeighborsRoute,
  NeighborsParams,
  parseNeighborsParams,
} from '../core';
import { NeighborsPage } from '../ui';

const NeighborsPageRoute = () => {
  const dispatch = useDispatch();
  const params = useParams<NeighborsParams>();
  const { search } = useLocation();
  const parsed = parseNeighborsParams(params, search);
  const annotationId = parsed.success ? parsed.data.annotationId : null;

  // The validation screen keeps the annotation started when it hands over to
  // this page (same annotation id in the URL), so release it here unless we
  // are heading back to it.
  useEffect(() => {
    if (annotationId === null) return undefined;

    return () => {
      const { pathname } = window.location;
      const isReturningToAnnotation =
        isValidationPathname(pathname) &&
        getCurrentAnnotationId(pathname) === annotationId;

      if (!isReturningToAnnotation) dispatch(exitAnnotation(annotationId));
    };
  }, [annotationId, dispatch]);

  if (!parsed.success) return <Redirect to="/error?reason=not-found" />;

  return (
    <NeighborsPage
      annotationId={parsed.data.annotationId}
      pageNumber={parsed.data.pageNumber}
    />
  );
};

export const NeighborsRoutes = () => (
  <Switch>
    <Route
      path={documentNeighborsRoute()}
      exact
      component={NeighborsPageRoute}
    />
  </Switch>
);
